// The operator UI leads with the merchant's DBA ("doing business as")
// name wherever a single name identifies an application — the list, the
// detail header, confirmation prompts. The legal business name is still
// what goes on the wire to CardConnect and is still editable/visible in
// the edit modal; it's just not the headline the client wants operators
// scanning for.
//
// Falls back to the legal name when no DBA was captured (older rows,
// sole proprietors who never set one).

interface BusinessNamed {
  businessName?: string | null;
  dbaName?: string | null;
}

/** Name to show when one string has to identify the application. */
export function displayBusinessName(app: BusinessNamed): string {
  return app.dbaName?.trim() || app.businessName?.trim() || "";
}
